import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Requisito } from '../../_models/requisito';
import { RequisitosService } from '../../_services/requisitos.service';
import { RequisitoGarantiaModalidadService } from '../../_services/requisito-garantia-modalidad.service';
import { RequisitoGarantiaTipoRespaldoService } from '../../_services/requisito-garantia-tipo-respaldo.service';
import { RequisitoGarantiaModalidad } from '../../_models/requisito-garantia-modalidad';
import { RequisitoGarantiaTipoRespaldo } from '../../_models/requisito-garantia-tipo-respaldo';
import { forkJoin } from 'rxjs';
import { Modalidad } from '../../_models/modalidad';
import { TipoRespaldo } from '../../_models/tipo-respaldo';
import { ModalidadService } from '../../_services/modalidad.service';
import { TipoRespaldoService } from '../../_services/tipo-respaldo.service';
import { Table } from 'primeng/table';
import {ListaService} from "../../_services/lista.service";

@Component( {
  templateUrl: 'requisitos-editar.component.html',
  selector: 'app-requisito-editar'
} )
export class RequisitosEditarComponent implements OnInit {

  formulario: FormGroup;
  guardando: boolean;
  codExiste = false;
  submitted: boolean;
  tabSeleccionado = 'INFO';
  carInformacionInicial = true;
  requisito: Requisito;
  listadoRequistos: Requisito[] = [];
  formModalidad: FormGroup;
  formTipoRespaldo: FormGroup;
  subModalidad = false;
  subTipoRespaldo = false;
  lisRequisitoModalidad: RequisitoGarantiaModalidad[] = [];
  lisRequisitoTipoRespaldo: RequisitoGarantiaTipoRespaldo[] = [];
  lisRequisitoModalidadTodos: RequisitoGarantiaModalidad[] = [];
  lisRequisitoTipoRespaldoTodos: RequisitoGarantiaTipoRespaldo[] = [];
  lisModalidad: SelectItem[] = [];
  lisModalidadTodos: Modalidad[] = [];
  lisTipoRespaldo: SelectItem[] = [];
  lisTipoRespaldoTodos: TipoRespaldo[] = [];
  @ViewChild('dt') tabModalidad: Table;
  @ViewChild('dt2') tabRespaldo: Table;
  rows = 5;
  colModalidad: any[] = [];
  colTipoRespaldo: any[] = [];
  tabConfiguracion = {
    MOD: {
      arregloTodos: 'lisRequisitoModalidadTodos',
      arreglo: 'lisRequisitoModalidad',
      llave: 'idModalidad',
      llaveNombre: 'nombre',
      nombre: 'modalidad',
      principal: 'idRequisitoGarantiaModalidad',
      servicio: 'reqGarantiaModalidadService',
      formulario: 'formModalidad',
      submit: 'subModalidad',
      lista: 'lisModalidad',
      listaTodos: 'lisModalidadTodos',
      tabla: 'tabModalidad'
    },
    TIPRES: {
      arregloTodos: 'lisRequisitoTipoRespaldoTodos',
      arreglo: 'lisRequisitoTipoRespaldo',
      llave: 'idTipoRespaldo',
      llaveNombre: 'nombre',
      nombre: 'tipoRespaldo',
      principal: 'idRequisitoGarantiaTipoRespaldo',
      servicio: 'reqGarantiaTipoRespaldoService',
      formulario: 'formTipoRespaldo',
      submit: 'subTipoRespaldo',
      lista: 'lisTipoRespaldo',
      listaTodos: 'lisTipoRespaldoTodos',
      tabla: 'tabRespaldo'
    }
  };
  codModalidad = 'MOD';
  codRespaldo = 'TIPRES';
  listasTiposOcupaciones: SelectItem[] = [];
  listasTiposPersonas: SelectItem[] = [];

  constructor( private navServicio: NavService,
               private router: Router,
               private route: ActivatedRoute,
               private formBuilder: FormBuilder,
               private requisitosServicio: RequisitosService,
               private reqGarantiaModalidadService: RequisitoGarantiaModalidadService,
               private reqGarantiaTipoRespaldoService: RequisitoGarantiaTipoRespaldoService,
               private modService: ModalidadService,
               private tipRespaldoService: TipoRespaldoService,
               private confirmacionServicio: ConfirmationService,
               private lisService: ListaService,) {
  }

  ngOnInit(): void {
    this.colModalidad = [
      { field: 'modalidad', header: this.navServicio.buscarMensaje( 'REQUISITOS.LBL_MODALIDAD' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.colTipoRespaldo = [
      { field: 'tipoRespaldo', header: this.navServicio.buscarMensaje( 'REQUISITOS.LBL_TIPORESPARDO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      if ( params[ 'id' ] ) {
        forkJoin( this.requisitosServicio.obtenerPorId( params[ 'id' ] ),
          this.reqGarantiaModalidadService.listadoPorIdRequisito( params[ 'id' ] ),
          this.reqGarantiaTipoRespaldoService.listadoPorIdRequisito( params[ 'id' ] ),
          this.cargarServicios(),
          this.lisService.getMasterDetails( 'ListasTiposPersonas' ),
          this.lisService.getMasterDetails('ListasTiposOcupaciones')).subscribe( ( [ res, lisModalidad, lisTipoRespaldo, carga, listasTiposPersonas, listasTiposOcupaciones ] ) => {
          this.requisito = res;
          this.listasTiposOcupaciones = listasTiposOcupaciones.map( s => ( { label: s.nombre, value: s.idLista } ) );
          this.listasTiposPersonas = listasTiposPersonas.map( s => ( { label: s.nombre, value: s.idLista } ) );
          this.lisRequisitoModalidadTodos = lisModalidad;
          this.lisRequisitoTipoRespaldoTodos = lisTipoRespaldo;
          this.cargarListado( this.codModalidad );
          this.cargarListado( this.codRespaldo );
          this.lisRequisitoTipoRespaldo = [ ...this.lisRequisitoTipoRespaldo ];
          this.lisRequisitoModalidad = [ ...this.lisRequisitoModalidad ];
          this.finalizarCarga();
        } );
      } else {
        forkJoin( this.requisitosServicio.listado(),
          this.cargarServicios() ).subscribe( ( [ listado, carga ] ) => {
          this.listadoRequistos = listado;
          this.finalizarCarga();
        } );
      }
    } );
  }

  async cargarServicios() {
    const [ lisModalidad, lisRespaldo ] = await
      forkJoin( this.modService.listadoModalidadesHabilitadas(),
        this.tipRespaldoService.listadoHabilitado() ).toPromise();
    this.lisModalidadTodos = lisModalidad;
    this.lisTipoRespaldoTodos = lisRespaldo;
    return true;
  }

  finalizarCarga() {
    this.cargarFormulario();
    this.cargarFormularioTablas( this.codModalidad );
    this.cargarFormularioTablas( this.codRespaldo );
    this.cargarItems( this.codModalidad );
    this.cargarItems( this.codRespaldo );
    this.carInformacionInicial = false;
  }

  cargarFormulario() {
    this.formulario = this.formBuilder.group( {
      idRequisitoGarantia: [ this.requisito ? this.requisito.idRequisitoGarantia : null ],
      codigo: [ this.requisito ? this.requisito.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombre: [ this.requisito ? this.requisito.nombre : null, [ Validators.required ] ],
      montoMaximo: [ this.requisito ? this.requisito.montoMaximo : null, [ Validators.required ] ],
      // numeroDeudores: [ this.requisito ? this.requisito.numeroDeudores : null, [ Validators.required ] ],
      garantia: [ this.requisito ? this.requisito.garantia : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.requisito ? this.requisito.indicadorHabilitado : true ],
      indicadorRequiereFondoGarantiaIdonea: [ this.requisito ? this.requisito.indicadorRequiereFondoGarantiaIdonea : false ],
      indicadorUnidadCredito: [ this.requisito ? this.requisito.indicadorUnidadCredito : false ]
    } );
  }


  get f() {
    return this.formulario.controls;
  }

  validarCodigo() {
    this.codExiste = !!this.listadoRequistos.find( x => x.codigo === this.f.codigo.value );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid || this.codExiste ) {
      return;
    } else if ( this.lisRequisitoModalidad.length === 0 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'REQUISITOS.MSG_DEBESELECCIONARMODALIDAD' )
      } );
      return;
    }
    this.guardando = true;
    const formulario = this.formulario.value;
    if ( formulario.idRequisitoGarantia ) {
      this.requisitosServicio.actualizar( formulario ).subscribe( res => {
        this.requisito = formulario;
        this.verificarTablasAnexas( this.requisito.idRequisitoGarantia, 2 );
      }, error1 => {
        this.navServicio.setMesage( 3 );
        this.guardando = false;
      } );
    } else {
      this.requisitosServicio.crear( formulario ).subscribe( res => {
        this.requisito = res;
        this.f.idRequisitoGarantia.setValue( this.requisito.idRequisitoGarantia );
        this.verificarTablasAnexas( this.requisito.idRequisitoGarantia, 1 );
      }, error1 => {
        this.navServicio.setMesage( 3 );
        this.guardando = false;
      } );
    }
  }

  verificarTablasAnexas( idRequisito: string, tipo: number ) {
    forkJoin( this.validarGuardado( idRequisito, this.codModalidad ),
      this.validarGuardado( idRequisito, this.codRespaldo ) ).subscribe( r => {
      this.finalizarGuardado( tipo );
    } );
  }

  finalizarGuardado( tipo: number ) {
    this.navServicio.setMesage( tipo );
    this.tabSeleccionado = 'PRODUCTO';
    this.formulario.markAsPristine();
    this.guardando = false;
  }

  goBack( dirty: boolean ) {
    if ( dirty || this.validarArreglo( this.codRespaldo ) || this.validarArreglo( this.codModalidad ) ) {
      this.confirmacionServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_SALIRSINGUARDAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'requisito',
        accept: () => {
          this.regresar();
        }
      } );
    } else {
      this.regresar();
    }
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'PRODUCTO';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'RESPALDO';
        break;
      }
      case 3: {
        this.tabSeleccionado = 'UNIDADCREDITO';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  regresar() {
    this.router.navigate( [ 'apl/requisitos' ] );
  }

  cargarFormularioTablas( tipo: string ) {
    this[ this.tabConfiguracion[ tipo ].formulario ] = this.formBuilder.group( {
      items: [ null, [ Validators.required ] ]
    } );
  }

  fTablas( tipo: string ) {
    return this[ this.tabConfiguracion[ tipo ].formulario ].controls;
  }

  cargarListado( tipo: string ) {
    this[ this.tabConfiguracion[ tipo ].arreglo ] = this[ this.tabConfiguracion[ tipo ].arregloTodos ].filter( x => x.indicadorHabilitado );
  }

  cargarItems( tipo: string ) {
    this[ this.tabConfiguracion[ tipo ].lista ] = [];
    this[ this.tabConfiguracion[ tipo ].listaTodos ].forEach( e => {
      if ( !this[ this.tabConfiguracion[ tipo ].arreglo ].find( x => x[ this.tabConfiguracion[ tipo ].llave ] === e[ this.tabConfiguracion[ tipo ].llave ] ) ) {
        this[ this.tabConfiguracion[ tipo ].lista ].push( {
          label: e[ this.tabConfiguracion[ tipo ].llaveNombre ],
          value: e[ this.tabConfiguracion[ tipo ].llave ]
        } );
      }
    } );
  }

  agregarTabla( tipo: string ) {
    this[ this.tabConfiguracion[ tipo ].submit ] = true;
    if ( !this[ this.tabConfiguracion[ tipo ].formulario ].valid ) {
      return;
    }
    this.fTablas( tipo ).items.value.forEach( e => {
      const m = this[ this.tabConfiguracion[ tipo ].listaTodos ].find( x => x[ this.tabConfiguracion[ tipo ].llave ] === e );
      const nuevo = {} as any;
      nuevo[ this.tabConfiguracion[ tipo ].llave ] = e;
      nuevo[ this.tabConfiguracion[ tipo ].nombre ] = m ? m[ this.tabConfiguracion[ tipo ].llaveNombre ] : null;
      this[ this.tabConfiguracion[ tipo ].arreglo ] = [ ...this[ this.tabConfiguracion[ tipo ].arreglo ], nuevo ];
    } );
    this[ this.tabConfiguracion[ tipo ].submit ] = false;
    this.cargarItems( tipo );
    this[ this.tabConfiguracion[ tipo ].formulario ].reset();
  }

  inhabilitarTabla( elemento: any, tipo: string ) {
    const indice = this[ this.tabConfiguracion[ tipo ].arreglo ].findIndex( x => x[ this.tabConfiguracion[ tipo ].llave ] === elemento[ this.tabConfiguracion[ tipo ].llave ] );
    if ( indice >= 0 ) {
      const pagina = this[ this.tabConfiguracion[ tipo ].tabla ].first > 0 ? ( this[ this.tabConfiguracion[ tipo ].tabla ].first / this.rows ) + 1 : 1;
      this[ this.tabConfiguracion[ tipo ].arreglo ].splice( indice, 1 );
      this[ this.tabConfiguracion[ tipo ].arreglo ] = [ ...this[ this.tabConfiguracion[ tipo ].arreglo ] ];
      this.cargarItems( tipo );
      setTimeout( () => {
        const canPagina = this[ this.tabConfiguracion[ tipo ].tabla ].totalRecords > 0 ? ( Math.floor( ( this[ this.tabConfiguracion[ tipo ].tabla ].totalRecords - 1 ) / this.rows ) ) + 1 : 1;
        if ( pagina > canPagina ) {
          this[ this.tabConfiguracion[ tipo ].tabla ].first = pagina > 1 ? ( pagina - 2 ) * this.rows : 0;
        }
      }, 5 );
    }
  }

  validarArreglo( tipo: string ): boolean {
    const habilitados = this[ this.tabConfiguracion[ tipo ].arregloTodos ].filter( x => x.indicadorHabilitado );
    if ( habilitados.length !== this[ this.tabConfiguracion[ tipo ].arreglo ].length ) {
      return true;
    }
    const b = [ ...this[ this.tabConfiguracion[ tipo ].arreglo ] ].sort( ( a, x ) => {
      return a[ this.tabConfiguracion[ tipo ].llave ] - x[ this.tabConfiguracion[ tipo ].llave ];
    } );
    habilitados.sort( ( x, y ) => {
      return x[ this.tabConfiguracion[ tipo ].llave ] - y[ this.tabConfiguracion[ tipo ].llave ];
    } );
    return !!habilitados.find( ( x, y ) => x[ this.tabConfiguracion[ tipo ].llave ] !== b[ y ][ this.tabConfiguracion[ tipo ].llave ] );
  }

  async validarGuardado( idRequisito: string, tipo: string ) {
    const registros = [];
    this[ this.tabConfiguracion[ tipo ].arreglo ].forEach( e => {
      const existe = this[ this.tabConfiguracion[ tipo ].arregloTodos ].find( x => x[ this.tabConfiguracion[ tipo ].llave ] === e[ this.tabConfiguracion[ tipo ].llave ] );
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        registros.push( existe );
      } else if ( !existe ) {
        e.idRequisitoGarantia = idRequisito;
        e.indicadorHabilitado = true;
        this[ this.tabConfiguracion[ tipo ].arregloTodos ].push( e );
        registros.push( e );
      }
    } );

    this[ this.tabConfiguracion[ tipo ].arregloTodos ].forEach( e => {
      if ( e.indicadorHabilitado && !this[ this.tabConfiguracion[ tipo ].arreglo ].find( y => e[ this.tabConfiguracion[ tipo ].llave ] === y[ this.tabConfiguracion[ tipo ].llave ] ) ) {
        e.indicadorHabilitado = false;
        registros.push( e );
      }
    } );

    if ( registros.length > 0 ) {
      const resultado = await this[ this.tabConfiguracion[ tipo ].servicio ].bulk( registros ).toPromise();
      this[ this.tabConfiguracion[ tipo ].arregloTodos ].forEach( e => {
        if ( !e[ this.tabConfiguracion[ tipo ].principal ] ) {
          const valor = resultado.find( x => x[ this.tabConfiguracion[ tipo ].llave ] === e[ this.tabConfiguracion[ tipo ].llave ] );
          if ( valor ) {
            e[ this.tabConfiguracion[ tipo ].principal ] = valor[ this.tabConfiguracion[ tipo ].principal ];
          }
        }
      } );
    }
    return true;
  }


}
